import React, {FC, useEffect, useState} from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import {useTypedSelector} from "../reducers";
import {ShineDataInterface} from "../model/ShineDataInterface";
import Select from "react-select";
import {Link} from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { handleError } from "../error/ErrorHandler";

const ShineRequest: FC = () => {

    const initialSelFileList: any = [
        {value: "", label: ""}
    ]
    const [isFileDataNotEmpty, setIsFileDataNotEmpty] = useState(false);
    const [fileDataValidationMsg, setFileDataValidationMsg] = useState("");
    const [fileAllList, setFileAllList] = useState(initialSelFileList); // nec
    const [values, setReactSelect] = useState({
        selectedOption: []
    });
    const { register, handleSubmit, setValue, formState: { errors } } = useForm();
    const { loginUser } = useTypedSelector(state => state.auth);
    const navigate = useNavigate();

    const handleMultiChange = (selectedOption: any) => {
        const rqstFileStr: string[] = [];
        selectedOption.forEach((m: { value: string; }) => {
            rqstFileStr.push(m.value)
        })
        setValue("rqstFile", rqstFileStr);
        setReactSelect({ selectedOption });
        setFileDataValidationMsg("")
        setIsFileDataNotEmpty(true)
    };

    const insertData = async (insertData: ShineDataInterface) => {
        try {
            await axios.post('/api/data', insertData);
            alert('성공적으로 신청했습니다.')
            navigate('/request/list');
        } catch(err: any) {
            console.log(err.response);
            alert('신청에 실패했습니다.');
        }
    }
    const onSubmit = (data?: any) => {
        if (!data) return;
        let isRqstFileNull = data['rqstFile'] === null ||
                data['rqstFile'] === '' ||
                data['rqstFile'] === undefined ||
                data['rqstFile'].length === 0;
        if (isRqstFileNull) {
            setIsFileDataNotEmpty(false);
            setFileDataValidationMsg("필수 선택값입니다.")
        } else {
            if (loginUser?.usrId !== null || loginUser?.usrId !== '') data["usrId"] = loginUser?.usrId as string;
                    setIsFileDataNotEmpty(true)
                    data['rqstFile'] = data.rqstFile.toString();
                    insertData(data);
        }
    };

    const getFileDataAll = async() => {
        try {
            const res = await axios.get('/api/catalog/option/all');
            if (res.data) setFileAllList(res.data);
        } catch(err) {
            handleError(err);
        }
    };

    useEffect(() => {
        getFileDataAll();
    }, [loginUser, register, isFileDataNotEmpty, fileDataValidationMsg]);

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className={'shine-request-wrapper'}>
                <div className={'shine-request'}>
                    <div className={'common-form-table-wrapper'}>
                        <div className={'common-form-table'}>
                            <div className={'common-form-table-header-wrapper'}>
                                <div className={'common-form-table-header-title'}>

                                </div>
                                <div className={'common-form-table-header-alert'}>
                                    * 필수사항입니다.
                                </div>
                            </div>
                            <div className={'common-form-table-body-wrapper'}>
                                <div className={'common-form-table-body'}>
                                    <label>
                                        <span className={'common-form-input-label'}>
                                            연구 목적
                                            <span className={'common-form-input-label-alert'}>*</span>
                                        </span>
                                        <input className={'common-form-input-text lg'} {...register("rschPrps",{required: true})}/>
                                        {errors.rschPrps && <span className={'error-msg'}>필수 입력값입니다.</span>}
                                    </label>
                                    <label>
                                        <span className={'common-form-input-label'}>
                                            연구 기간
                                            <span className={'common-form-input-label-alert'}>*</span>
                                        </span>
                                        <input className={'common-form-input-text lg'} {...register("rschPrd",{required: true})}/>
                                        {errors.rschPrd && <span className={'error-msg'}>필수 입력값입니다.</span>}
                                    </label>
                                    <label>
                                        <span className={'common-form-input-label'}>
                                            신청자명
                                            <span className={'common-form-input-label-alert'}>*</span>
                                        </span>
                                        <input className={'common-form-input-text lg'} value={loginUser?.usrNm} {...register("usrNm",{required: true})} readOnly={true} />
                                        <input className={'d-none'} value={loginUser?.usrId} {...register("usrId",{required: true})} readOnly={true} />
                                    </label>
                                    <label>
                                        <span className={'common-form-input-label'}>
                                            소속기관
                                            <span className={'common-form-input-label-alert'}>*</span>
                                        </span>
                                        <input type={'radio'} name={'orgYn'} value={'N'} checked={loginUser?.orgYn === 'N'} readOnly={true} /> 개인
                                        <input className={'ml-10'} type={'radio'} value={'Y'} checked={loginUser?.orgYn === 'Y'} readOnly={true}/> 컨소시엄 참여 기관
                                    </label>
                                    <label>
                                        <span className={'common-form-input-label'}>
                                            기관명
                                        </span>
                                        <input className={'common-form-input-text lg'} value={loginUser?.orgNm} readOnly={true} />
                                    </label>
                                    <label className={'last'}>
                                        <span className={'common-form-input-label'}>
                                            신청 가능한 데이터
                                            <span className={'common-form-input-label-alert'}>*</span>
                                        </span>
                                        <Select
                                            className="input-border-color width-590"
                                            name="filters"
                                            placeholder="데이터를 선택해주세요."
                                            value={values.selectedOption}
                                            options={fileAllList}
                                            onChange={handleMultiChange}
                                            isMulti
                                        />
                                    </label>
                                    <label className={'last no-padding-top'}>
                                        <span className={'common-form-input-label'} />
                                        <span className={isFileDataNotEmpty ? '' : 'error-msg'}>{fileDataValidationMsg}</span>
                                    </label>
                                    <label className={'last'}>
                                        <span className={'common-form-input-label'}>
                                            데이터 신청 사유
                                            <span className={'common-form-input-label-alert'}>*</span>
                                        </span>
                                        <textarea className={'common-form-input-textarea'} placeholder={'500자 이내'} {...register("rqstRsn",{required: true})}/>
                                    </label>
                                    <label className={'last no-padding-top'}>
                                        <span className={'common-form-input-label'} />
                                    {errors.rqstRsn && <span className={'error-msg no-margin-left'}>필수 입력값입니다.</span>}
                                    </label>
                                </div>
                            </div>
                            <div className={'common-form-button-wrapper'}>
                                <Link to={'/'}><button className={'common-button light'}>취소</button></Link>
                                <button className={'common-button primary ml-10'}>확인</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    );
}

export default ShineRequest;
